import { action } from 'satcheljs';
export default action('ON_SET_DECLINE_EXISTING_CALENDAR_EVENTS', function (option) {
    return {
        option: option,
    };
});
//# sourceMappingURL=setDeclineExistingCalendarEvents.js.map